import { render } from "./fondocambiante.vue?vue&type=template&id=4c380b42&scoped=true"
import script from "./fondocambiante.vue?vue&type=script&lang=js"
export * from "./fondocambiante.vue?vue&type=script&lang=js"

import "./fondocambiante.vue?vue&type=style&index=0&id=4c380b42&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4c380b42"]])

export default __exports__